var path = 'src/app/notifications/notifications.html';
var html = "<div ng-repeat=\"notification in notifications\"> <div class=alert ng-class=getClass(notification)> <button type=button class=close aria-label=Close ng-click=notification.remove()><span aria-hidden=true>&times;</span></button> <strong><span ng-if=notification.icon class=fa ng-class=notification.icon></span> {{notification.title}}</strong> {{notification.message}} </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/notifications/notifications.html
 ** module id = 373
 ** module chunks = 0
 **/